'use es6';

import { COLUMN_CLASSNAME, MODULE_CLASSNAME } from 'layout-data-lib/constants';
import { CELL_ATTRIBUTE } from '../constants/dndAreaDomConstants';
import { addOrRemoveClassesToElement } from '../dom/manipulators';
import { getDndAreaElementForNode } from '../dom/dndAreaDomSelectors';

// Decide between the css_id and css_id_str params and cleanup the string if necessary.
// Note, copied render code to cleanup css_id_str that removes the `#` and any spaces from:
// https://git.hubteam.com/HubSpot/content4j/blob/1cdbce77024ebd71201103e27eeb5d3de3fc2b3e/ContentLayouts/src/main/java/com/hubspot/content/layouts/PageHtmlSectionGenerator.java#L108
//
// Also, it seems like the backend code for pages and email is slightly different. EmailHtmlSectionGenerator
// does fallback from css_id to css_id_str, but PageHtmlSectionGenerator only looks at css_id.
// Nonetheless, I'm fairly certain is is fine to use the same fallback code for both.
const cssIdFromCellParams = ({
  css_id,
  css_id_str
}) => {
  const cssStr = css_id || css_id_str;
  return cssStr ? cssStr.replace(/#/g, '').replace(/ /g, '') : '';
};
export const setDndAreaColumnId = (columnElement, id) => {
  // Edge case - if layerElement is `null` in `renderDndAreaLayer`
  if (!columnElement) {
    return;
  }
  columnElement.setAttribute(CELL_ATTRIBUTE, id);
};
export const resizeDndAreaColumnElement = (element, width) => {
  const classArray = element.className.split(' ');
  const spanClass = classArray.find(c => /^span\d+$/.test(c));
  element.classList.remove(spanClass);
  element.classList.add(`span${width}`);
};
export const updateCellElementStyleAttributes = (element, currentCellParams, previousCellParams = {}) => {
  if (currentCellParams.css_style || previousCellParams.css_style) {
    element.style.cssText = currentCellParams.css_style;
  }
  if (currentCellParams.css_id || currentCellParams.css_id_str || previousCellParams.css_id || previousCellParams.css_id_str) {
    element.id = cssIdFromCellParams({
      css_id: currentCellParams.css_id,
      css_id_str: currentCellParams.css_id_str
    });
  }
  if (currentCellParams.css_class || previousCellParams.css_class) {
    const previousClasses = previousCellParams.css_class ? previousCellParams.css_class.split(' ') : [];
    const currentClasses = currentCellParams.css_class ? currentCellParams.css_class.split(' ') : [];
    addOrRemoveClassesToElement(element, previousClasses, currentClasses);
  }
};
export const createDndAreaColumnElement = ({
  treeId,
  type,
  cellParams
} = {}) => {
  const element = document.createElement('div');
  element.classList.add('widget-span');
  if (type === 'cell') {
    element.classList.add(COLUMN_CLASSNAME, 'widget-type-cell');
  } else {
    element.classList.add(MODULE_CLASSNAME);
  }
  if (treeId) {
    element.setAttribute(CELL_ATTRIBUTE, treeId);
  }
  if (type) {
    element.setAttribute('data-widget-type', type);
  }
  if (cellParams) {
    updateCellElementStyleAttributes(element, cellParams);
  }
  return element;
};
export const updateWidthsOfColumns = cellsWithChangedWidth => {
  cellsWithChangedWidth.forEach(cell => {
    const element = getDndAreaElementForNode(cell);
    resizeDndAreaColumnElement(element, cell.getWidth());
  });
};